import PropTypes from "prop-types";
import PopoverMenu from "PopoverMenu";

import BrokerIcon from "icons/global/outline_16px/book_open_16px.svg";
import CompanyIcon from "icons/global/outline_16px/buildings_16px.svg";
import MemberIcon from "icons/global/outline_16px/person_16px.svg";

const PortalSwitcherMenu = ({ activeApp, isAdmin, isBroker, isMember, menuTitle }) => {
    const linkData = {
      broker: {
        title: menuTitle["BrokerApp"],
        show: (isBroker && activeApp !== "BrokerApp"),
        link: "/broker/dashboard",
        icon: <BrokerIcon />,
      },
      admin: {
        title: menuTitle["CompanyAdminApp"],
        show: (isAdmin && activeApp !== "CompanyAdminApp"),
        link: "/company/dashboard",
        icon: <CompanyIcon />,
      },
      member: {
        title: menuTitle["MemberPortalApp"],
        show: (isMember && activeApp !== "MemberPortalApp"),
        link: "/dashboard",
        icon: <MemberIcon />,
      },
    };
  
    return (
      <PopoverMenu linkData={linkData} top="88px" left="182px" />
    );
  }
  
  PortalSwitcherMenu.propTypes = {
    activeApp: PropTypes.string,
    isAdmin: PropTypes.bool,
    isBroker: PropTypes.bool,
    isMember: PropTypes.bool,
  }

  export default PortalSwitcherMenu;
